import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EMPTY, IN_PROGRESS, DONE, ERROR } from "constants/Status";
import { IPaymentSettingsGetResult } from "types/paymentSettings";
import { getPaymentSettings } from "selectors";
import { PaymentSettingsActionsCreator } from "../../actions/paymentSettingsActionsCreator";

export interface IUsePaymentSettings {
    getPaymentSettings: (snapshotId: string) => IPaymentSettingsGetResult;
    loadPaymentSettings: (snapshotId: string) => Promise<void>;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (): IUsePaymentSettings => {
    const dispatch = useDispatch();
    const getPaymentSettingsAction = PaymentSettingsActionsCreator.getPaymentSettings;
    const paymentSettings = useSelector(getPaymentSettings);
    const [loadPaymentSettingsStatus, setLoadPaymentSettingsStatus] = useState(EMPTY);
    const loadPaymentSettingsRequest = (snapshotId: string) =>
    new Promise((resolve, reject) =>
        dispatch(getPaymentSettingsAction(snapshotId, resolve, reject))
        );


    const loadPaymentSettings = async (snapshotId: string) => {
        setLoadPaymentSettingsStatus(IN_PROGRESS);
        try {
            await loadPaymentSettingsRequest(snapshotId);
            setLoadPaymentSettingsStatus(DONE);
        }catch(error) {
            setLoadPaymentSettingsStatus(ERROR);
            throw error;
        }
    };

    return {
        loadPaymentSettings,
        getPaymentSettings: () => paymentSettings
    };
};